/* eslint-disable react/no-array-index-key */
import React from 'react'

import { CtaButton } from '../../components'
import richTextRenderer from '../../components/RichTextParser/RichTextParser'
import { SectionContainer } from '../../layouts'
import { ContentParser } from '../../utils/helpers'
import {
  buttonClassName,
  buttonsContainer,
  contentTitle,
  extraContent,
  extraKicker,
  headingContainerStyling,
  newPriceCard,
  priceCardsContainer,
  priceSeparator,
  sectionContent,
  sectionFooter,
  sectionHeader,
} from './PricingSection.module.css'

const PricingSection = ({ lang, slice }) => {
  const {
    financebutton,
    membershipbutton,
    treatmentfootercontent,
    treatmentfootertitle,
    treatmentpricingbackground,
    treatmentpricingheading,
    treatmentpricingkicker,
    treatmentpricingwidth,
  } = slice
  const priceCards = ContentParser(slice, 'treatmentpricecard').filter(
    (item) => item.pricecardprice,
  )
  const buttonLink =
    financebutton?.url || lang === 'nl' ? ' /betaalplan' : '/en/finance'

  const secondButtonLink =
    membershipbutton?.url || lang === 'nl'
      ? ' /loyalty-programma/'
      : '/en/loyalty-program/'

  return (
    <SectionContainer
      backGround={treatmentpricingbackground}
      containerwidth={treatmentpricingwidth}
      extraDescriptionClassName={extraContent}
      extraHeaderClassName={sectionHeader}
      extraHeadingContainerClassName={headingContainerStyling}
      extraKickerClassName={extraKicker}
      heading={treatmentpricingheading}
      id="pricing"
      kicker={treatmentpricingkicker}
      // renderedContent={treatmentpricingcontent}
      withHeader
    >
      <div className={buttonsContainer}>
        <CtaButton
          extraClassName={buttonClassName}
          title={financebutton?.tilte || 'Talk to us about finance'}
          type="secondary"
          url={buttonLink}
          wide
        />
        <CtaButton
          extraClassName={buttonClassName}
          title={membershipbutton?.tilte || 'Become a member'}
          type="secondary"
          url={secondButtonLink}
          wide
        />
      </div>
      {priceCards.length > 0 && (
        <div className={priceCardsContainer}>
          {priceCards.map((card, index) => {
            const { pricecardprice, pricecardtitle } = card
            return (
              <div key={`${index}-${pricecardtitle}`} className={newPriceCard}>
                <span>{pricecardtitle}</span>
                <div className={priceSeparator} />
                {richTextRenderer(pricecardprice)}
              </div>
            )
          })}
        </div>
      )}
      {(treatmentfootercontent || treatmentfootertitle) && (
        <div className={sectionFooter}>
          {treatmentfootertitle && (
            <p className={contentTitle}>{treatmentfootertitle}</p>
          )}
          {treatmentfootercontent && (
            <div className={sectionContent}>
              {richTextRenderer(treatmentfootercontent)}
            </div>
          )}
        </div>
      )}
    </SectionContainer>
  )
}

export default PricingSection
